import React from "react";
import { Link } from "react-router-dom";
import { findCategory } from "@/lib/api";

/**
 * Clean, editorial essay row.
 * variant: "row" (default) or "grid" (for grid layouts on section pages)
 */
export default function EssayCard({ essay, variant = "row" }) {
    const cat = findCategory(essay.category);

    if (variant === "grid") {
        return (
            <Link
                to={`/essay/${essay.slug}`}
                className="group block"
                data-testid={`essay-card-${essay.slug}`}
            >
                {essay.cover_image && (
                    <div className="frame aspect-[4/3] mb-5">
                        <img src={essay.cover_image} alt={essay.title} />
                    </div>
                )}
                <div className="flex items-center gap-3 mb-2">
                    <span className="overline">{cat?.short || essay.category}</span>
                    <span className="text-xs text-[rgb(var(--ink-2))]/60">· {essay.read_minutes} min</span>
                </div>
                <h3 className="text-xl font-bold text-[rgb(var(--teal))] group-hover:text-[rgb(var(--orange))] transition-colors leading-snug">
                    {essay.title}
                </h3>
                {essay.subtitle && (
                    <p className="mt-2 text-[15px] italic text-[rgb(var(--ink-2))]">{essay.subtitle}</p>
                )}
                <p className="mt-3 text-[15px] text-[rgb(var(--ink-2))] line-clamp-3">{essay.excerpt}</p>
                <span className="mt-4 inline-block btn-text">Read →</span>
            </Link>
        );
    }

    // Row layout for section listing pages
    return (
        <Link
            to={`/essay/${essay.slug}`}
            className="group block border-b hairline py-8 grid md:grid-cols-12 gap-6"
            data-testid={`essay-card-${essay.slug}`}
        >
            <div className="md:col-span-3">
                <p className="overline">{cat?.short || essay.category}</p>
                <p className="mt-2 text-xs text-[rgb(var(--ink-2))]/60">
                    {new Date(essay.created_at).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                    })}{" "}
                    · {essay.read_minutes} min
                </p>
            </div>
            <div className="md:col-span-6">
                <h3 className="text-xl md:text-2xl font-bold text-[rgb(var(--teal))] group-hover:text-[rgb(var(--orange))] transition-colors leading-snug">
                    {essay.title}
                </h3>
                {essay.subtitle && (
                    <p className="mt-1 text-[15px] italic text-[rgb(var(--ink-2))]">{essay.subtitle}</p>
                )}
                <p className="mt-3 text-[15px] text-[rgb(var(--ink-2))] line-clamp-2">{essay.excerpt}</p>
            </div>
            <div className="md:col-span-3 flex md:justify-end items-start">
                <span className="btn-text">Read essay →</span>
            </div>
        </Link>
    );
}
